'use client';

import { useEffect, useRef } from 'react';
import { recordProductEvent } from '@/lib/product-analytics';

export function EmbedTrackingFrame({ partnerSlug }: { partnerSlug?: string }) {
  const recorded = useRef(false);
  useEffect(() => {
    if (window.parent === window) return;
    if (!recorded.current) {
      recordProductEvent('widget_loaded', { surface: 'widget', ...(partnerSlug && { partner_slug: partnerSlug }) });
      recorded.current = true;
    }
    // Only dimensions leave the frame; shipment references/results stay inside.
    const content = document.querySelector('.track-embed .track-main');
    if (!content) return;
    const resize = () => window.parent.postMessage({ type: 'shipzy:resize', height: Math.ceil(content.getBoundingClientRect().height) }, '*');
    const observer = new ResizeObserver(resize);
    observer.observe(content);
    resize();
    return () => observer.disconnect();
  }, [partnerSlug]);
  return null;
}
